import axiosInstance from '@/utils/api.js'

var state = {
  emergencyCalls: []
}

var getters = {
  EMERGENCY_CALLS: (state) => {
    return state.emergencyCalls
  }
}

var mutations = {
  SET_EMERGENCY_CALLS: (state, payload) => {
    state.emergencyCalls = payload
  }
}

var actions = {
  GET_EMERGENCY_CALLS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/emergency_calls')
    if (result.status === 200) {
      context.commit('SET_EMERGENCY_CALLS', result.data)
    }
  },
  CREATE_UPDATE_EMERGENCY_CALLS: (context, payload) => {
    return axiosInstance.post('/settings/emergency_calls', payload)
  },
  DELETE_EMERGENCY_CALLS: (context, payload) => {
    return axiosInstance.delete('/settings/emergency_calls?service_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/emergencyCalls.js